import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function NilaiSiswa({ user }) {
  const [nilaiList, setNilaiList] = useState([]);
  useEffect(() => {
    async function ambil() {
      let query = supabase
        .from("nilai")
        .select("*, siswa(nama_lengkap)")
        .order("tanggal", { ascending: false });
      if (user.role === "siswa") {
        const { data: dataSiswa } = await supabase
          .from("siswa")
          .select("id")
          .ilike("nama_lengkap", user.nama)
          .single();
        if (dataSiswa) query = query.eq("siswa_id", dataSiswa.id);
        else {
          setNilaiList([]);
          return;
        }
      }
      const { data } = await query;
      setNilaiList(data || []);
    }
    ambil();
  }, [user]);

  const formatTanggal = (dateStr) => {
    if (!dateStr) return "-";
    return new Date(dateStr).toLocaleDateString("id-ID", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <div
      style={{
        padding: "20px",
        maxWidth: "480px",
        margin: "0 auto",
        background: "#F8FAFC",
        minHeight: "100vh",
        fontFamily: "sans-serif",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "20px",
        }}
      >
        <Link to="/" style={{ color: "#64748B" }}>
          <ChevronRight size={24} style={{ transform: "rotate(180deg)" }} />
        </Link>
        <h2 style={{ margin: 0, color: "#1E293B" }}>Laporanku</h2>
      </div>
      {nilaiList.length === 0 && (
        <p style={{ textAlign: "center", color: "#94A3B8", marginTop: 50 }}>
          Belum ada laporan evaluasi.
        </p>
      )}
      {nilaiList.map((item) => (
        <div
          key={item.id}
          style={{
            background: "white",
            borderRadius: "16px",
            padding: "20px",
            marginBottom: "15px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.03)",
            border: "1px solid #F1F5F9",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "10px",
            }}
          >
            <span
              style={{
                background: "#E0F2FE",
                color: "#0369A1",
                padding: "4px 10px",
                borderRadius: "20px",
                fontSize: "12px",
                fontWeight: "bold",
              }}
            >
              {formatTanggal(item.tanggal)}
            </span>
            <span style={{ fontSize: "12px", color: "#94A3B8" }}>
              {item.mata_pelajaran}
            </span>
          </div>
          <p style={{ margin: 0, color: "#475569", lineHeight: "1.6" }}>
            {item.catatan}
          </p>
        </div>
      ))}
    </div>
  );
}
